import { AlmeUIMessage } from './response';
import Module from './module';
import { MessageTypes } from './message-types';
import { settings } from '../settings/settings-util';
import { Reducer } from 'redux';
import { AlmeState } from '../wireup/AlmeState';

export default abstract class ResponseHandler extends Module{
    _validRequestTypes: MessageTypes[];

    constructor(validRequestTypes: MessageTypes[], passedSettings?: typeof settings, reducer?: Reducer<AlmeState>){
        super(passedSettings, reducer);
        this._validRequestTypes = validRequestTypes;
    }

    doesHandle(message: AlmeUIMessage): boolean {
        return message.messageType ? this._validRequestTypes.includes(message.messageType) : false;
    }

    abstract process(message: AlmeUIMessage): AlmeUIMessage;
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/types/response-handler.ts